// eslint-disable-next-line import/prefer-default-export
export function sanitizeObject(input: object) {
  Object.keys(input).forEach((key) => {
    if (!input[key as keyof object]) {
      delete input[key as keyof object];
    }
  });
}
